'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _appendLocale = require('../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

require('./OMTabs.scss');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
var OMTabs = function (_Component) {_inherits(OMTabs, _Component);function OMTabs() {var _temp, _this, _ret;_classCallCheck(this, OMTabs);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      activeTabKey: _this.props.defaultActiveTabKey }, _this.








    handleSelect = function (key) {
      _this.setState({ activeTabKey: key });
      if (_this.props.onSelect) {
        _this.props.onSelect(key);

        if (_this.props.routeData && _this.props.withLink) {var
          location = _this.props.routeData.location;
          _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/' + location + '/' + key));
        }
      }
    }, _this.

    renderTabHead = function (props) {
      var isActive = props.id === _this.state.activeTabKey;
      var title = typeof props.title === 'function' ? props.title() : props.title;
      var handleSelect = function handleSelect() {return !props.isDisabled && _this.handleSelect(props.id);};
      return (
        _react2.default.createElement('div', {
            key: props.id,
            className: (0, _classnames2.default)('om-tab', props.headerClassName, { 'active-om-tab': isActive, 'disabled-om-tab': props.isDisabled }),
            onClick: handleSelect },

          _react2.default.createElement('div', { className: 'om-tab-title' },
            title)));



    }, _this.

    renderTabHeads = function () {return _this.props.children.filter(function (comp) {return !!comp;}).map(function (child) {return _this.renderTabHead(child.props);});}, _this.

    renderChildren = function () {return _react2.default.Children.map(
      _this.props.children.filter(function (comp) {return !!comp;}),
      function (child) {
        var isActive = child.props.id === _this.state.activeTabKey;
        var childProps = {
          _handleSelect: _this.handleSelect,
          isActive: isActive,
          className: !isActive ? 'hidden-om-tab' : '' };

        return _react2.default.cloneElement(child, Object.assign({}, childProps));
      });}, _temp), _possibleConstructorReturn(_this, _ret);}OMTabs.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var defaultActiveTabKey = _ref.defaultActiveTabKey;if (defaultActiveTabKey && defaultActiveTabKey !== this.props.defaultActiveTabKey) {this.setState({ activeTabKey: defaultActiveTabKey });}};OMTabs.prototype.


  render = function render() {
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)('om-tabs-container', this.props.className) },
        _react2.default.createElement('div', { className: 'om-tab-header' },
          this.renderTabHeads()),

        _react2.default.createElement('div', { className: 'om-tab-content' },
          this.renderChildren())));



  };return OMTabs;}(_react.Component);


OMTabs.propTypes = {
  onSelect: _propTypes2.default.func,
  defaultActiveTabKey: _propTypes2.default.oneOfType([
  _propTypes2.default.string,
  _propTypes2.default.number]),

  className: _propTypes2.default.string,
  children: _propTypes2.default.array,
  withLink: _propTypes2.default.bool,
  routeData: _propTypes2.default.object,
  locale: _propTypes2.default.string };exports.default =


OMTabs;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMTabs/OMTabs.js
// module id = 2793
// module chunks = 0